<template>
    <div>
        <b-button v-b-modal="'popupFile' + prefix" :disabled="disabled">
            <i class="fe-upload mr-1"></i>
            เพิ่มไฟล์เอกสาร
        </b-button>
        <br><br>

        <b-modal :id="'popupFile' + prefix" :ref="'popupFile' + prefix" size="lg" title="อัพโหลดเอกสาร">
            <input type="file" id="files" name="files" ref="fileupload" multiple @change="loadTextFromFile">
            <br><br>
            <div v-for="(file, index) in Files" :key="index">
                <div class="row d-flex align-items-center">
                    <div class="col-sm-3">{{ file.Name + file.Extension }}</div>
                    <div class="col-sm-3">
                        <select name="" id="" class="form-control" v-model="file.FileCategoryId">
                            <option value="">เลือกประเภทเอกสาร</option>
                            <option :value="fileCategory.Id" v-for="(fileCategory, indexCategory) in FileCategories"
                                :key="indexCategory">{{ fileCategory.Name }}</option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" placeholder="รายละเอียด (ถ้ามี)"
                            v-model="file.Description">
                    </div>
                    <div class="col-sm-2"><button class="btn btn-danger" @click="removeFile(index)">ลบ</button></div>
                </div>
                <hr>
            </div>

            <template #modal-footer>
                <small class="text-danger">เลือกประเภทเอกสารให้ครบก่อนกดยืนยัน</small>
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" variant="success" @click="ok()">
                    ยืนยัน
                </b-button>
                <b-button size="sm" variant="danger" @click="cancel()">
                    ยกเลิก
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "FormUpload2",
    props: {
        values: {
            type: Array,
            required: true,
        },
        FileCategories: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    components: {
    },
    data() {
        return {
            Files: [],
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        loadTextFromFile(ev) {
            let self = this;
            for (const file of ev.target.files) {
                let reader = new FileReader();
                // reader.onload = e => this.$emit("load", e.target.result);
                reader.onload = () => {
                    let result = reader.result.split("base64,");
                    self.Files.push({
                        Name: file.name.split('.').slice(0, -1).join('.'),
                        Extension: '.' + file.name.split('.').pop(),
                        Size: file.size,
                        Type: file.type,
                        Description: '',
                        FileCategoryId: '',
                        Path: '',
                        Value: result[1],
                        AddNew: 1
                    })
                };
                reader.readAsDataURL(file);
                // reader.readAsText(file);
            }
            this.$refs.fileupload.value = null;
            // const file = ev.target.files[0];
        },
        removeFile(index) {
            this.Files.splice(index, 1);
        },
        ok() {
            let found = this.Files.find(element => element.FileCategoryId == '');
            if (!found) {
                this.$emit('addFile', this.Files);
                this.Files = [];
                this.$refs['popupFile' + this.prefix].hide()
            } else {
                console.log('test')
            }
        },
        cancel() {
            this.Files = [];
            this.$refs['popupFile' + this.prefix].hide()
        }
    }
};
</script>